export default __webpack_public_path__ + "static/media/re6.b2b790db.png";